module.exports = __webpack_public_path__ + "static/img/MQcon1@2x.5eb3ea64.png";